import styled from 'styled-components';

export const SettingItemHeaderLabel = styled.p`
  font-size: 16px;
  font-weight: bold;
`;
